
import { mixins, Options } from 'vue-class-component';
import CampaignWidgetMixin from '@/mixins/campaignWidget';
import Question from '../api/models/question';
import { Redemption } from '../api/models/redemption';
import { QuestionnaireSubmission } from '../api/models/submission';
import LazyImage from './LazyImage.vue';
import MToken from './MToken.vue';

@Options({
  components: {
    LazyImage,
    MToken
  }
})
export default class MQuestionnaire extends mixins(CampaignWidgetMixin) {
  publicPollQuestionResults: any[] = [];
  resubmittingId = '';
  isSubmittingRedemption = false;

  async created() {
    for (let i = 0; i < this.state.questions.length; i++) {
      const question = this.state.questions[i];
      if (question.type == 8) {
        await this.formatQuestionResults(question.id);
      }
    }
  }

  async formatQuestionResults(questionId: number) {
    const results = await this.state.RedeemAPIClient.getQuestionResults(
      parseInt(this.mmid!),
      questionId
    );
    this.publicPollQuestionResults.push(results);
  }

  questionTypeForSubmission(questionId: number) {
    const questions = this.state.questions;
    return questions.find((question: Question) => question.id == questionId)?.type;
  }

  get redemptionToToken() {
    const currentRedemption = this.state.activeRedemption!;
    const questions = this.state.questions;

    let submissions = currentRedemption.submissions!;

    for (let i = 0; i < submissions.length; i++) {
      // @ts-ignore
      let question = questions.find((question: any) => question.id == submissions[i].questionId);
      // @ts-ignore
      submissions[i].questionText = question.text;
    }

    currentRedemption.submissions = submissions;

    return currentRedemption;
  }

  editSubmission() {
    this.$store.commit(`${this.mmid}/setActiveEligibleToken`, this.redemptionToToken, {
      root: true
    });
    // @ts-ignore
    this.resubmittingId = this.redemptionToToken!.id;
  }

  async submitQuestionnaire(submitEvent: any) {
    this.isSubmittingRedemption = true;
    try {
      let submissions: QuestionnaireSubmission[] = [];
      const elements = submitEvent.target.elements;

      // Skip last one which is the submit button itself
      for (let i = 0; i < elements.length - 1; i++) {
        const data = elements[i];
        const val = data.value;
        const id = data.id;

        if (data.type == 'checkbox') {
          submissions.push({
            questionId: parseInt(id),
            answer: val == 'on' ? 'True' : 'False'
          });
        } else {
          submissions.push({
            questionId: parseInt(id),
            answer: val
          });
        }
      }

      const { network, contractAddress, tokenId } = this.state.activeEligibleToken!;
      const redemption = new Redemption(network, contractAddress, tokenId, submissions);
      const oauthToken = await this.getOAuth();
      const res = await this.state.RedeemAPIClient.submitRedemption(
        oauthToken!,
        parseInt(this.mmid!),
        redemption,
        this.resubmittingId
      );
      this.setRedemptionDetails(res);

      await this.updateState(true);
      this.publicPollQuestionResults = [];
      for (let i = 0; i < this.state.questions.length; i++) {
        const question = this.state.questions[i];
        if (question.type == 8) {
          await this.formatQuestionResults(question.id);
        }
      }
    } catch (e) {
      alert('Error encountered during submission. Please try again.');
    } finally {
      this.isSubmittingRedemption = false;
    }
  }
}
